<div class="add-application-party-dialog container-fluid">
  <form [formGroup]="formGroup">
    <div class="row pt-4">
      <div class="col">
        <h3 class="subheading-2">{{ title() }}</h3>
      </div>
    </div>

    @if (!data.fixedRole) {
    <div class="row">
      <div class="col-6">
        <mat-form-field>
          <mat-label>Party type</mat-label>
          <mat-select [formControl]="formControlRole">
            <mat-option [value]="'guarantor'">Guarantor</mat-option>
            <mat-option [value]="'trustee'">Trustee</mat-option>
            <mat-option [value]="'partner'">Partner</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    }

    @if (needsOwner() && data.fixedOwnerId == null) {
    <div class="row">
      <div class="col-6">
        <mat-form-field>
          <mat-label>{{ formControlRole.value === 'trustee' ? 'Trustee of' : 'Partner of' }}</mat-label>
          <mat-select [formControl]="formControlOwner">
            @for (owner of data.ownerEntities; track owner.commercialEntityId) {
            <mat-option [value]="owner.commercialEntityId">{{ owner.entityName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    }
    @if (needsOwner() && data.fixedOwnerId != null && fixedOwnerName()) {
    <div class="row">
      <div class="col-6">
        <p><strong>{{ formControlRole.value === 'trustee' ? 'Trustee of' : 'Partner of' }}:</strong> {{ fixedOwnerName() }}</p>
      </div>
    </div>
    }

    <div class="row">
      <div class="col">
        <business-number-search
          [searchFn]="data.businessNumberSearchFn"
          [formControl]="formControlOrganisation">
        </business-number-search>
      </div>
    </div>

    <div class="row pb-4">
      <div class="col">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
          <button mat-flat-button type="button" [disabled]="disableSubmission()" (click)="onSubmit()">Add &amp; run KYB</button>
        </div>
      </div>
    </div>
  </form>
</div>
